import React, { useEffect, useRef, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from 'chart.js';
import 'chartjs-plugin-dragdata'
import ReactTooltip from "react-tooltip";
import zoomPlugin from 'chartjs-plugin-zoom'
import DashboardColors from "../Dashboard/DashboardColors";
import { Button } from "react-md";
// import annotationPlugin from 'chartjs-plugin-annotation';
ChartJS.register(...registerables);
ChartJS.register(zoomPlugin);
// ChartJS.register(annotationPlugin);

const colors = {
  red: "#bb0000",
  grey: "#666666",
  grey: "#999",
  green: "#c4dac0",
  orange: "#ecc9b0",
  lightRed: "#ecc4c4",

  // violet: "#7d2476",
  // teal: "#2197a7",
  violet: "#bb0000",
  teal: "#666666",
  violet: "#7d2476",
  teal: "#2197a7",
  // violet: "#bb0000",
  // teal: "#666666",
};

const BarChart = ({ chartName, chartNameTooltip, labels, medianAt, stepSize, showLegend, height, width, thickness, values, min, 
  max, handleSetGoal, category, isLocked, goals, courseID, assignIndex, catIndex, quizID, yAxisLable }) => {

    const chartRef = useRef(null);
    let dragFlag = false;
  
    // console.debug("values------", values, labels)

  let data = {
    labels: values && values.length ? labels : [],
    datasets: [
      {
        label: "Goal",
        data: goals,
        backgroundColor: DashboardColors.PRACTICE_GOAL_BAR_BG,
        dragData: true,
        barThickness: thickness/1.5,
        borderRadius: 2,
      },
      {
        label: "Accuracy",
        data: values.map(ele => ele.value),
        backgroundColor: values.map((ele) => ele.color),
        borderRadius: 2
      },
      
    ],
  };

  const moveScroll = () => {
    const chart = chartRef.current;
    const {
      ctx,
      canvas,
      chartArea: { top, right, bottom, left, width, height },
      scales: {x, y},
    } = chart;

    canvas.addEventListener('click', (event) => {


      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const radius = 8;

      if (x >= left - radius && x <= left + radius &&
        y >= height / 2 + top - radius && y <= height / 2 + top + radius) {
          chart.options.scales.x.min = chart.options.scales.x.min - 1
          chart.options.scales.x.max = chart.options.scales.x.max - 1

          if (chart.options.scales.x.min <= 0) {
            chart.options.scales.x.min = 0
            chart.options.scales.x.max = 1
          }
      } else if (x >= right - radius && x <= right + radius &&
        y >= height / 2 + top - radius && y <= height / 2 + top + radius) {
          chart.options.scales.x.min = chart.options.scales.x.min + 1
          chart.options.scales.x.max = chart.options.scales.x.max + 1
          if (chart.options.scales.x.max >= data.datasets[1].data.length) {
            chart.options.scales.x.min = data.datasets[1].data.length - 2
            chart.options.scales.x.max = data.datasets[1].data.length
          }
      }


      chart.update();
    })
  }

  useEffect(() => {
    if (values?.length > 3) {
      moveScroll()
    }
  }, [values])

  const drawLine = {
    id: "drawLine",
    afterDraw(chart, args, options) {
      const {
        ctx,
        canvas,
        chartArea: { top, right, bottom, left, width, height },
        scales: {x, y},
      } = chart;
      ctx.save()
      
      // draw a line
      ctx.strokeStyle = '#665466'
      ctx.lineWidth = 1
      ctx.strokeRect(left, height-10, width, 0)

       // Add text on top of the line
      ctx.fillStyle = "#665466";
      ctx.textAlign = "left";
      ctx.font = "10px sans-serif";
      ctx.fillText("M", left-10, height-8);

      ctx.restore();

    },
  };

  const moveChart = {
    id: "moveChart",

    afterDatasetsDraw(chart, args, pluginOptions) {
      const {
        ctx, 
        canvas,
        data,
        chartArea: { top, right, bottom, left, width, height },
      } = chart;

      const angle = Math.PI / 180

      class CircleChevron {
        draw(ctx, x1, pixel, radius) {
          // circle
          ctx.beginPath();
          ctx.lineWidth = 3;
          ctx.strokeStyle = 'rgba(102, 102, 102, 0.5)';
          ctx.fillStyle = 'white';
          ctx.arc(x1, height/2 + top, radius, angle * 0, angle * 360, false);
          ctx.stroke();
          ctx.fill();
          ctx.closePath();

          // chevron arrow
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.strokeStyle = '#741a76';
          ctx.moveTo(x1 + pixel, height/2 + top - 4);
          ctx.lineTo(x1 - pixel, height/2 + top);
          ctx.lineTo(x1 + pixel, height/2 + top + 4);
          ctx.stroke();
          ctx.closePath();
        }
      }

      let radius = 8;
    
      if (data?.labels?.length) {
        if (chart.options.scales.x.min > 0) {
          let drawCircleLeft = new CircleChevron();
          drawCircleLeft.draw(ctx, left, 4, radius);
        }

        if (chart.options.scales.x.max < data.datasets[1].data.length) {
          let drawCircleRight = new CircleChevron();
          drawCircleRight.draw(ctx, right, -4, radius);
        }  
      }

     
    }
  }


  const arrowPointerV2 = {
    id: 'arrowPointer',
    beforeDatasetsDraw(chart, args, plugins) {
      const {ctx, config, data, canvas, chartArea:{top, bottom, left, right, width, height}, scales:{x, y}} = chart;
      ctx.save();

      // Set initial position
      let initialY = y.getPixelForValue(-20);
      let yPosition = initialY;
      let direction = -1; // Initial direction of movement (up)

      // Animation loop
      function animate() {
        // Clear the canvas
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.clearRect(x.getPixelForValue(1.78) - 20, y.getPixelForValue(-20) - 15, 40, 40);
        

        // Update the y-position based on the direction
        yPosition += direction * 0.5; // Adjust the speed as needed

        // Reverse the direction if the text reaches the top or bottom
        if (yPosition <= initialY - 5 || yPosition >= initialY + 5) {
          direction *= -1;
        }

        // Draw the text at the updated position
        ctx.fillStyle = '#741a76';
        ctx.font = '12px FontAwesome';
        ctx.fillText('\uf062', x.getPixelForValue(1.78), yPosition);

        // Request the next animation frame
        // requestAnimationFrame(animate);
      }

      animate()
      
      ctx.restore(); 
    }
  }
  const arrowPointer = {
    id: 'arrowPointer',
    afterDatasetsDraw(chart, args, plugins) {
      const { ctx, config, data, canvas, chartArea: { top, bottom, left, right, width, height }, scales: { x, y } } = chart;
      const dataset = data.datasets[0]; // Assuming you have only one dataset
      
      ctx.save();
  
      // Set initial position
      let lastBarIndex = dataset.data.length - 1;
      let lastBarX = x.getPixelForValue(lastBarIndex);
      let lastBarY = y.getPixelForValue(0);
  
  
      ctx.fillStyle = '#741a76';
      ctx.font = '12px FontAwesome';
      ctx.fillText('\uf062', lastBarX - 12, lastBarY + 20);

      ctx.restore();
    }
  };

  const emptyChart = {
    id: 'emptyChart',
    afterDatasetsDraw: chart => {
      const { ctx, config, data, canvas, chartArea: { top, bottom, left, right, width, height }, scales: { x, y } } = chart;
      // console.debug("values============", data)
      if (data?.labels?.length === 0) {
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = "12px Arial";
        ctx.fillStyle = "gray";
        ctx.fillText('No data available', width/1.25, height/2);
        ctx.restore();
      }
    }
  };

  

  return (
    <React.Fragment>
      <div
        style={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "14px",
          color: "#666666",
        }}
        className="my-2 mb-4"
      >
        {chartName}
        <ReactTooltip id='chartname_index_tooltip' place='right' effect="float" className='tool-tip tooltip-css'/>
        <small 
          data-tip={chartNameTooltip} 
          data-for='chartname_index_tooltip'>
          <i className="fa-solid fa-circle-info ml-2 text-secondary" ></i>
        </small>
        
      </div>
      <ReactTooltip
          id='locked'
          multiline={true}
          place="top"
          effect="float"
        />
      <div className="position-relative chart-container">
      <div className="chart-container-body">
        {/* {isLocked ? <div className="locked-overlay" 
          data-for='locked'
          data-tip='You cannot set your time goal until your accuracy is atleast 90%.'>
        </div> : null} */}
        {/* <div className="no-chart-data">No data available</div> */}
      <Bar
        ref={chartRef} 
        data={data}
        height={height}
        width={width}
        // plugins={ chartName === "Time" ? [drawLine] : []}
        plugins={ values?.length ? (values?.length > 3 ? [moveChart] : []) : [emptyChart]}
        // onClick={moveScroll}
        options={{
          skipNull: true,
          layout: {
            padding: {
              right: 11
            },
          },
          barSpacing: 1,
          // normalized: false,
          animation: true,
          // maintainAspectRatio: true,
          // responsive: true,

          onHover:  (event, chartElement, chart) => {
            if (chartElement) {
              event.native.target.style.cursor = chartElement[0] && chartElement[0].datasetIndex === 1 && chartElement[0].index === values.length - 1  ? 'grabbing' : 'default'; 
            }
          },
          barThickness: thickness,
          plugins: {
            // annotation: {
            //   annotations: {
            //     line1: {
            //       type: 'line',
            //       yMin: medianAt,
            //       yMax: medianAt,
            //       borderColor: '#999',
            //       borderWidth: 1,
            //       display: medianAt ? true : false
            //     },
            //       label1: {
            //       type: 'label',
            //       xValue: 0,
            //       xAdjust: 0,
            //       yValue: medianAt,
            //       yAdjust: 10,
            //       // backgroundColor: 'rgba(245,245,245)',
            //       content: [medianAt ? `M=${medianAt}` : ''],
            //       font: {
            //         size: 12
            //       },
            //       display: medianAt ? true : false
            //     }
            //   }
            // },
            // zoom: {
            //   pan: {
            //     enabled: false,
            //     mode:'x',
            //     scaleMode: 'x',
            //   },
            //   zoom: {
            //     drag: {
            //       enabled: false,
            //     },
            //     wheel: {
            //       enabled: false,
            //     },
            //     pinch: {
            //       enabled: false,
            //     },
            //     scaleMode:'x',
            //     mode:'x'
            //   }
            // },
            tooltip: {
              // yAlign: 'bottom',
              xAlign: 'right',
              displayColors: false,
              bodyAlign: 'center',
              callbacks: {
                title: function(context) {
                  if (context[0] && context[0].dataIndex < values.length - 1) {
                    return
                  }
                  if (isLocked) {
                    return 'You cannot set your time goal until \n your accuracy is atleast 90%.'
                  }
                  return 'Drag to set goal'
                },
                label: function(context) {
                  if (isLocked && context.dataIndex === values.length - 1) {
                    return null;
                  }
                  
                  return parseInt(context.formattedValue, 10)
                },
              },
            },
            legend: {
                display: showLegend
            },
            dragData: {
              onDrag: (event, datasetIndex, index, value) => {
                if (isLocked) {
                  return false;
                }
                if (index === data.labels.length - 1) {
                  data.datasets[datasetIndex].data[index] = value;
                  dragFlag = true;
                } else {
                  return false;
                }
              },
              onDragEnd: (event,datasetIndex, index, value) => {
                if (isLocked) {
                  return false;
                }
                
                if (index === data.labels.length - 1 && dragFlag && !isLocked) {
                  event.target.style.cursor = 'default'
                  let catKey = `${category.subjectID}_${category.topicID}_${category.categoryID}`
                  let subCatKey = `${category.subjectID}_${category.topicID}_${category.categoryID}_${category.subCategoryID}`
                  handleSetGoal(value, chartName, catKey, subCatKey, courseID, assignIndex, catIndex, index, quizID);
                  dragFlag = false;
                } else {
                  return false;
                }
                
              },
            }
          },
          title: {
            display: false,
            text: "Accuracy Index",
            fontSize: 14,
          },

          scales: {
            x: {
                title: {
                  display: true,
                  text: "Attempt #"
                },
                grid: {
                  display: false
                },
                ticks: {
                  font: {
                    size: 10,
                  }
                },
                min: values ? values.length - 2: 0,
                max: values ? values.length : 2,
                // min: 0,
                // max: 2
              },
            y:
              {
                type: chartName === 'Time' ? 'logarithmic' :'linear',
                beginAtZero: true,
                grid: {
                  display: false,
                },
                title: {
                  display: true,
                  text: yAxisLable ? yAxisLable : ""
                },
                min: min,
                max: max,
                ticks: {
                  stepSize: 10,
                }
              },
          },
        }}
      />
      </div>
      </div>
      
    </React.Fragment>
  );
};

export default BarChart;
